import React from 'react';
import ReactDOM from 'react-dom';
import mapboxgl from 'mapbox-gl';
import './main.css';
//import county_data from './updated_04-04-20_UScounty.geojson';
//import state_data from './us_states.geojson';


mapboxgl.accessToken = 'pk.eyJ1Ijoic2FubWlzYW4iLCJhIjoiY2sxOWxqajdjMDB2ZzNpcGR5aW13MDYzcyJ9.WsMnhXizk5z3P2C351yBZQ';

// Feature list that need to be visualized.
const options = [{
  name: 'Confirmed',
  description: 'Number of people confirmed',
  property: 'confirmed',
  stops: [
    [0, '#fff5f0'],
    [20, '#fee0d2'],
    [100, '#fcbba1'],
    [500, '#fc9272'],
    [1000, '#fb6a4a'],
    [5000, '#ef3b2c'],
    [10000, '#cb181d'],
    [50000, '#99000d']
  ]
}, {
  name: 'Confirmed per 10K Pop',
  description: 'Number of people confirmed per 10K population',
  property: 'confirmed_per10k',
  stops: [
    [0, '#fff5f0'],
    [2.03, '#fee0d2'],
    [3.16, '#fcbba1'],
    [8.46, '#fc9272'],
    [12.61, '#fb6a4a'],
    [20.00, '#ef3b2c'],
    [50.37, '#cb181d'],
    [102.19, '#99000d']
  ]
}, {
  name: 'Confirmed per Hospital Bed',
  description: 'Number of people confirmed per licensed hospital bed',
  property: 'confirmed_per_bed',
  stops: [
    [0, '#fff5f0'],
    [0.01, '#fee0d2'],
    [0.08, '#fcbba1'],
    [0.12, '#fc9272'],
    [0.17, '#fb6a4a'],
    [1.07, '#ef3b2c'],
    [2.80, '#cb181d'],
    [17.10, '#99000d']
  ]
}, {
  name: 'Death',
  description: 'Number of deaths',
  property: 'deaths',
  stops: [
    [0, '#fff5f0'],
    [5, '#fee0d2'],
    [23, '#fcbba1'],
    [39, '#fc9272'],
    [66, '#fb6a4a'],
    [124, '#ef3b2c'],
    [200, '#cb181d'],
    [2624, '#99000d']
  ]
}, {
  name: 'Death Count per 10K Pop',
  description: 'Number of deaths per 10K population',
  property: 'death_per10k',
  stops: [
    [0, '#fff5f0'],
    [0.03, '#fee0d2'],
    [0.08, '#fcbba1'],
    [0.42, '#fc9272'],
    [0.58, '#fb6a4a'],
    [1.28, '#ef3b2c'],
    [2.26, '#cb181d'],
    [3.93, '#99000d']
  ]
}, {
  name: 'Daily New Confirmed',
  description: 'Number of people confirmed daily',
  property: 'daily_confirmed',
  stops: [
    [0, '#fff5f0'],
    [20, '#fee0d2'],
    [50, '#fcbba1'],
    [100, '#fc9272'],
    [200, '#fb6a4a'],
    [400, '#ef3b2c'],
    [900, '#cb181d'],
    [1400, '#99000d']
  ]
}];

class ChoroplethMap extends React.Component {
  mapRef = React.createRef();
  map;
  tooltipContainer;

  constructor(props) {
    super(props);
    this.state = {
      // init first feature to display
      active: options[0]
    };
  }

  componentDidUpdate() {
    this.setFill();
  }

  componentDidMount() {
    // Container to put React generated content in.
    this.tooltipContainer = document.createElement('div');

    this.map = new mapboxgl.Map({
      container: this.mapRef.current,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [-98, 38.88],
      zoom: 3
    });

    this.map.on('load', () => {
      this.map.addSource('countries', {
        type: 'geojson',
        data: 'UScounty.geojson'
      });

      this.map.addSource('states',{
        type: 'geojson',
        data: 'us_states.geojson'
      });

      // add state-borders
      this.map.addLayer({
        'id': 'state-borders',
        'type': 'line',
        'source': 'states',
        'layout': {},
        'paint': {
        'line-color': '#fff5f0',
        'line-width': 2.5
        }
      });

      this.map.addLayer({
        id: 'countries',
        type: 'fill',
        source: 'countries'
      }, 'waterway-label');
      this.setFill();
    });

    // Create a popup, but don't add it to the map yet.
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
      });

    this.map.on('mousemove', 'countries', (e) => {
      const descriptions = [{
        countyName: e.features[0].properties.county_name,
        confirm_num: e.features[0].properties.confirmed,
        confirm_10k: e.features[0].properties.confirmed_per10k,
        confirm_bed: e.features[0].properties.confirmed_per_bed,
        death_num: e.features[0].properties.deaths,
        death_10k: e.features[0].properties.death_per10k,
        confirm_daily: e.features[0].properties.daily_confirmed,
        population: e.features[0].properties.population,
        licensed_bed: e.features[0].properties.licensed_hospital_bed
      }];
      this.map.getCanvas().style.cursor = 'pointer';

      popup
      .setLngLat(e.lngLat)
      .setHTML('<b>May 11 2020</b></br><b>County: </b>'+descriptions[0].countyName+'<hr><b>Confirmed: </b>'+
              descriptions[0].confirm_num+'</br><b>Confirmed per 10K Pop: </b>'+descriptions[0].confirm_10k+
              '</br><b>Confirmed per Hospital Bed: </b>'+descriptions[0].confirm_bed+
              '</br><b>Number of Death: </b>'+descriptions[0].death_num+
              '</br><b>Death Count per 10K Pop: </b>'+descriptions[0].death_10k+
              '</br><b>Daily New Confirmed: </b>'+descriptions[0].confirm_daily+
              '</br>------------</br><b>Population: </b>'+descriptions[0].population+
              '</br><b>Licensed Hospital Beds: </b>'+descriptions[0].licensed_bed)
      .addTo(this.map);
    });

    this.map.on('mouseleave', 'countries', () => {
      this.map.getCanvas().style.cursor = '';
      popup.remove();
    });
    
  }

  setFill() {
    const { property, stops } = this.state.active;
    this.map.setPaintProperty('countries', 'fill-color', {
      property,
      stops
    }); 
    this.map.setPaintProperty('countries', 'fill-opacity', 0.75);   
  }

  render() {
    const { name, description, stops, property } = this.state.active;
    // present legend
    const renderLegendKeys = (stop, i) => {
      return (
        <div key={i} className='txt-s'>
          <span className='mr6 round-full w12 h12 inline-block align-middle' style={{ backgroundColor: stop[1] }} />
          <span>{`${stop[0].toLocaleString()}`}</span>
        </div>
      );
    }
    // present feature vis options
    const renderOptions = (option, i) => {
      return (
        <label key={i} className="toggle-container">
          <input onChange={() => this.setState({ active: options[i] })} checked={option.property === property} name="toggle" type="radio" />
          <div className="toggle txt-s py3 toggle--active-white">{option.name}</div>
        </label>
      );
    }

    return (
      <div>
        <div ref={this.mapRef} className="absolute top right left bottom" />
        <div className="toggle-group absolute top left ml12 mt12 border border--2 border--white bg-white shadow-darken10 z1">
          {options.map(renderOptions)}
        </div>
        <div className="bg-white absolute bottom right mr12 mb24 py12 px12 shadow-darken10 round z1 wmax180">
          <div className=''>
            <h2 className="large">{name}</h2>
            <p className='txt-s color-gray'>{description}</p>
          </div>
          {stops.map(renderLegendKeys)}
        </div>
      </div>
    );
  }
}

ReactDOM.render(<ChoroplethMap />, document.getElementById('visualization'));
